export enum FileType{
    Excel = 1,
    Csv =2,
}